module.exports = __webpack_public_path__ + "advisory-8c397925/delmaine-donson-4054103967b7420d1d417278ad371684.jpg";